import { EditOutlined } from '@ant-design/icons'
import Button from '@UI/New/Button'
import classes from './index.module.css'

export const WORK_DAYS = [
  { short: 'ПН', name: 'Понедельник', value: 0 },
  { short: 'ВТ', name: 'Вторник', value: 1 },
  { short: 'СР', name: 'Среда', value: 2 },
  { short: 'ЧТ', name: 'Четверг', value: 3 },
  { short: 'ПТ', name: 'Пятница', value: 4 },
  { short: 'СБ', name: 'Суббота', value: 5 },
  { short: 'ВС', name: 'Воскресенье', value: 6 },
]

export const normalizeWorkHours = (workHours = []) =>
  workHours
    .map((item) => ({
      ...item,
      week_day: Number(item.week_day),
      start_time: item.start_time?.slice(0, 5) ?? '',
      end_time: item.end_time?.slice(0, 5) ?? '',
    }))
    .sort((first, second) => {
      if (first.week_day !== second.week_day) {
        return first.week_day - second.week_day
      }

      return first.start_time.localeCompare(second.start_time)
    })

const WorkHoursSchedule = ({ workHours = [], editable = false, onEdit }) => {
  const normalizedWorkHours = normalizeWorkHours(workHours)

  return (
    <section className={classes.schedule}>
      <div className={classes.scheduleHeader}>
        <div>
          <h3 className={classes.scheduleTitle}>Рабочее время</h3>
          <p className={classes.scheduleDescription}>
            Периоды доступности для занятий
          </p>
        </div>
        {editable && (
          <Button
            color="primary"
            variant="outline"
            leftContent={<EditOutlined />}
            onClick={onEdit}
          >
            Настроить
          </Button>
        )}
      </div>

      <div className={classes.scheduleDays}>
        {WORK_DAYS.map((day) => {
          const intervals = normalizedWorkHours.filter(
            (item) => item.week_day === day.value,
          )

          return (
            <div className={classes.scheduleDay} key={day.value}>
              <div className={classes.dayLabel} title={day.name}>
                <span className={classes.dayShort}>{day.short}</span>
              </div>
              <div className={classes.scheduleIntervals}>
                {intervals.length ? (
                  intervals.map((interval) => (
                    <span
                      className={classes.timePill}
                      key={
                        interval.id ??
                        `${day.value}-${interval.start_time}-${interval.end_time}`
                      }
                    >
                      {interval.start_time}–{interval.end_time}
                    </span>
                  ))
                ) : (
                  <span className={classes.dayOff}>Выходной</span>
                )}
              </div>
            </div>
          )
        })}
      </div>
    </section>
  )
}

export default WorkHoursSchedule
